import React from 'react';
import Prismic from 'prismic-javascript';
import { RichText } from 'prismic-reactjs';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import Obfuscate from 'react-obfuscate';
import s from './NewsPage.scss';
import News from '../../components/News';
import Loader from '../../components/Loader';

const apiEndpoint = 'https://right2water.cdn.prismic.io/api/v2';
const { Elements } = RichText;

// Link Resolver
const linkResolver = news => {
  // Define the url depending on the document type
  if (news.type === 'page') {
    return `/page/${news.uid}`;
  } else if (news.type === 'document') {
    return `/document/${news.uid}`;
  } else if (news.type === 'news') {
    return `/news/${news.uid}`;
  }

  // Default to homepage
  return '/';
};

// -- Function to add unique key to props
const propsWithUniqueKey = (props, key) => Object.assign(props || {}, { key });

// -- HTML Serializer
// This function will be used to change the way the HTML is loaded
// @see https://prismic.io/docs/reactjs/beyond-the-api/html-serializer
const htmlSerializer = (type, element, content, children, key) => {
  let props = {};
  let elem;
  switch (type) {
    // Add a class to hyperlinks
    case Elements.hyperlink: {
      const targetAttr = element.data.target
        ? { target: element.data.target }
        : {};
      const relAttr = element.data.target ? { rel: 'noopener' } : {};
      props = Object.assign(
        {
          linkText: content,
          email: element.data.url || linkResolver(element.data),
        },
        targetAttr,
        relAttr,
      );

      if (element.data.url && element.data.url.includes('mailto:')) {
        elem = React.createElement(
          Obfuscate,
          propsWithUniqueKey(props, key),
          children,
        );
      }

      break;
    }
    // Return null to stick with the default behavior
    default: {
      elem = null;
    }
  }

  return elem;
};

class NewsPage extends React.Component {
  static propTypes = {
    newsUid: PropTypes.string.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      news: null,
      newsHasError: false,
      newsIsLoading: true,
    };
  }

  /**
   * Fetches current news data.
   *
   * @param endpoint
   */

  componentWillMount() {
    Prismic.api(apiEndpoint).then(api => {
      api.getByUID('news', this.props.newsUid).then(response => {
        if (response) {
          this.setState({ news: response });
          this.setState({ newsIsLoading: false });
        }
      });
    });
  }

  // @todo activate toolbar
  // Prismic team is currently working on a fix on an error sent when trying to login to GA account
  componentDidUpdate() {
    this.refreshToolbar();
  }

  refreshToolbar() {
    // To add experiment
    // @see https://prismic.io/docs/reactjs/beyond-the-api/in-website-preview#3_0-2.-include-the-prismic-toolbar-javascript-file
    // Launch the prismic.io toolbar
    this.endpoint = apiEndpoint;
    window.PrismicToolbar.setup(this.endpoint);
  }

  render() {
    if (this.state.newsHasError) {
      return <p>Error while loading news.</p>;
    }

    if (this.state.newsIsLoading) {
      return <Loader />;
    }

    return (
      <div className={s.wrapper}>
        <div className={s.container}>
          <News
            title={RichText.asText(this.state.news.data.title)}
            body={RichText.render(
              this.state.news.data.body,
              linkResolver,
              htmlSerializer,
            )}
            id={this.state.news.id}
            image_url={
              this.state.news.data.image.url && this.state.news.data.image.url
            }
            date={
              this.state.news.data.publication_date &&
              this.state.news.data.publication_date
            }
          />
        </div>
      </div>
    );
  }
}

export default withStyles(s)(NewsPage);
